import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';
import { SidebarService } from '~core/components/sidebar/sidebar.service';
import { TooltipTranslationService } from '~shared/translations';
import { ActionButton, ActionButtonEvent, Club, ImportHistory, SidebarOptions } from '~core/models';
import { ImportsService, NavigationService, ScreenSizeService, StorageService } from '~core/services';

/**
 * This component is responsible for the import of customers from CSV files.
 */
@UntilDestroy()
@Component({
  selector: 'app-import-history',
  templateUrl: 'import-history.component.html',
})

export class ImportHistoryComponent implements OnInit, OnDestroy {
  public selectedClub: Club;
  public importHistory: Array<ImportHistory> = [];
  public i18nEmptyState: string = $localize`:@@importComponent.text.noImportHistory:There is no import history`;

  public baseApi: string;
  public customQueries: Array<any> = [];

  public updateDataLoading: boolean = false;
  public updateLoading: boolean = false;

  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];
  public actionButtons: Array<ActionButton> = [];

  constructor(
    public sidebarService: SidebarService,
    public navigationService: NavigationService,
    public storage: StorageService,
    private screenSizeService: ScreenSizeService,
    private importService: ImportsService,
    private tablesTranslations: TablesTranslations,
    private tooltipTranslations: TooltipTranslationService,
  ) {
    this.storage.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
    this.navigationService.setCurrentPage('importHistory');
    this.navigationService.setCurrentBreadcrumbs(['crm', 'imports']);

    if (this.screenSizeService.screenSize === 'desktop') {
      this.sidebarService.setSidebar(new SidebarOptions(true, true));
    } else {
      this.sidebarService.setSidebar(new SidebarOptions(false, true));
    }

    this.importService.castImportHistoryList.pipe(untilDestroyed(this))
      .subscribe(data => {
        if (data != null) {
          this.importHistory = data;
        }
      });
  }

  public ngOnInit(): void {
    this.setUp();
    this.getLatestReminders(this.selectedClub.id);
  }

  public ngOnDestroy(): void { }

  /**
   * Adds the columns and keys for the table
   */
  protected setUp(): void {
    this.columns.push(
      this.tablesTranslations.i18nDate,
      this.tablesTranslations.i18nUsername,
      this.tablesTranslations.i18nType,
      this.tablesTranslations.i18nStatus,
    );
    this.keys.push(['createdAt', 'owner.fullName', 'translatedType', 'status']);
    this.actionButtons.push(
      new ActionButton({
        type: 'download',
        icon: '#esf-icon-download',
        tooltip: this.tooltipTranslations.i18nDownloadImportFile
      })
    );
  }

  /**
   * Sets the new import history list
   */
  public createImportHistoryList(imports: Array<any>): void {
    const data = this.importService.createImportHistoryClass(imports);
    this.importService.setImportHistoryList(data);
  }

  /**
   * Get the reminders for the current customer.
   */
  public getLatestReminders(id: number): any {
    const endpoint = this.importService.getImportHistoryEndpoint(id);
    this.baseApi = endpoint[0];
    this.customQueries = endpoint[1];
  }

  public actionButtonClicked(actionButton: ActionButtonEvent<any>): void {
    if (actionButton.type === 'download') {
      window.open(actionButton.data.media.contentUrl);
    }
  }
}
